import { styled } from '@mui/material/styles';
import { Menu } from 'shared/mui/Menu/Menu';

export const NotificationPopperMenu = styled(Menu)({
  '& .MuiMenu-paper': {
    boxShadow:
      '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.2)',
  },
});
